export const SITE_URL = process.env.REACT_APP_SITE_URL!
export const ACCOUNT_URL = process.env.REACT_APP_ACCOUNT_URL!
